import { Modal } from "@portal/components/layout/Modal";
import { ModalItemWithHeader } from "@portal/components/layout/ModalItemWithHeader";
import { Button } from "@portal/components/ui/Button";

type AdminBondingLineConflictModalProps = {
	onDismiss: () => void;
	onMoveToReview: () => void;
	onOverride: () => void;
};

export const AdminBondingLineConflictModal = ({
	onDismiss,
	onMoveToReview,
	onOverride,
}: AdminBondingLineConflictModalProps) => (
	<Modal onClickOutside={onDismiss}>
		<ModalItemWithHeader
			header="Exceed Carrier Line"
			onClose={onDismiss}
			className="w-[550px] max-w-[90vw]"
			bodyClassName="flex flex-col gap-[12px] px-5 py-4 text-[15px] text-primary"
		>
			<span>
				This update would cause the carrier's single bond or aggregate bonding limit to be exceeded.
			</span>
			<span>
				<span className="font-[550]">Override & Proceed</span> will save the update and preserve the
				current carrier assignment, status, rate, and premium.
			</span>
			<span>
				<span className="font-[550]">Move to Review</span> will save the update and move the request
				to review.
			</span>
			<div className="flex justify-center gap-[10px] pt-[8px] pb-[4px]">
				<Button
					color="primary"
					className="order-2 px-[20px] min-w-[120px]"
					onClick={onOverride}
					filled
				>
					Override & Proceed
				</Button>
				<Button color="secondary" className="order-1 min-w-[120px]" onClick={onMoveToReview}>
					Move to Review
				</Button>
			</div>
		</ModalItemWithHeader>
	</Modal>
);
